import { createClassName } from 'utils/createClassName';

import './navigationLayoutStyles.scss';

export const createNavigationLayoutClassName = createClassName(
  'navigationLayout'
);
